import { clearModulesForTest } from '@angular/core/src/linker/ng_module_factory_loader';
import { Component, ComponentFactory } from '@angular/core';
//import { createSelector } from 'reselect';
import { createSelector, createFeatureSelector } from '@ngrx/store';
import { pluck } from 'rxjs/operators';
import * as coreActions from '../action/core.actions';
import { Observable } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';
import { AppInternalSettings } from 'angular-framework-client-components/model/app-settings';
//import 'rxjs/add/operator/of';
//import * as stateModel from "./interfaces"
//import { update } from 'immutability-helper';

export interface DataEntity {
  createdOn: Date,
  expirationInterval: Number,
  data: Object
}

export interface Favorites {
  favorites: {}
}
export interface VideoStats {
  video_stats: {}
}
export interface InternalAppState {
  internalState: string | null;
}

export interface State {
  dataKeys: string[];
  dataEntities: { [key: string]: DataEntity };
  selectedDataKey: string | null;
  internalStateKey: string | null;
  dataLoading: boolean;
  dataLoaded: boolean;
  dataSlice: Object;
  internalState: { [key: string]: any };
};


export const initialDataState: State = {
  dataKeys: [],
  dataEntities: {},
  selectedDataKey: null,
  internalStateKey: null,
  dataLoading: false,
  dataLoaded: false,
  dataSlice: {},
  internalState: {}
};

export function reducer(state = initialDataState, action: coreActions.Actions): State {
  switch (action.type) {

    case coreActions.ActionTypes.LOAD_EXISTING_DATA_ITEM: {   
      return Object.assign({}, {
        dataLoading: false,
        dataLoaded: true,
        selectedDataKey: action["payload"]["apiUrl"],
        internalStateKey: null,
        dataKeys: state.dataKeys.slice(),
        dataEntities: Object.assign({}, state.dataEntities),
        dataSlice: {}, 
        internalState: state.internalState
      });
    }

    case coreActions.ActionTypes.LOAD_EXISTING: {     
      return Object.assign({}, {
        dataLoading: false,
        dataLoaded: true,
        selectedDataKey: action["payload"]["apiUrl"],
        internalStateKey: null,
        dataKeys: state.dataKeys.slice(),
        dataEntities: Object.assign({}, state.dataEntities),
        dataSlice: {}, 
        internalState: state.internalState
      });
    }

    case coreActions.ActionTypes.GET_DATA_SLICE: {    
      return Object.assign({}, {
        dataLoading: true,
        dataLoaded: false,
        selectedDataKey: action["payload"]["apiUrl"],
        internalStateKey: state.internalStateKey,
        dataKeys: state.dataKeys.slice(),
        dataEntities: Object.assign({}, state.dataEntities),
        dataSlice: {}, 
        internalState: state.internalState
      });
    }


    case coreActions.ActionTypes.GET_DATA_SLICE_SUCCESS: {   
      return Object.assign({}, {
        dataLoading: false,
        dataLoaded: true,
        selectedDataKey: action["payload"]["apiUrl"],
        internalStateKey: state.internalStateKey,
        dataKeys: state.dataKeys.slice(),
        dataEntities: Object.assign({}, state.dataEntities),    
        dataSlice: action["payload"]["data"],
        internalState: state.internalState
      });
    }
    
    case coreActions.ActionTypes.UPDATE_DATA_SLICE: {
      const currentObj = state.dataEntities[action["payload"]["apiUrl"]];
      delete state.dataEntities[action["payload"]["apiUrl"]];
      let slice = (currentObj["data"][action["payload"]["dataContainer"]] as Array<Object>)
        .find(row => row[action["payload"]["sliceKey"]] == action["payload"]["sliceKeyValue"]);      
      slice = action["payload"]["data"];
      const withoutSlice = (currentObj["data"][action["payload"]["dataContainer"]] as Array<Object>)
        .filter(row => row[action["payload"]["sliceKey"]] != action["payload"]["sliceKeyValue"]);
      currentObj["data"][action["payload"]["dataContainer"]] = [...withoutSlice, slice];
      //currentObj.factory = action["payload"]["factory"];
      return Object.assign({}, {
        dataLoading: false,
        dataLoaded: true,
        selectedDataKey: action["payload"]["apiUrl"],
        internalStateKey: state.internalStateKey,
        dataKeys: state.dataKeys.slice(),      
        dataEntities:  Object.assign({}, state.dataEntities, { 
            [action["payload"]["apiUrl"]] : currentObj
        }),
        dataSlice: {}, 
        internalState: state.internalState
      });
    }

    case coreActions.ActionTypes.LOAD_DATA_ITEM_SUCCESS: {
      if (!action["payload"]["apiUrl"]){
        return state;
      }
      const cleanUrl = action["payload"]["apiUrl"].replace(AppInternalSettings.settings.DATA_API_ENDPOINT,'');
      let storeKey = (cleanUrl.indexOf('?') > 1 ) ? cleanUrl.slice(0, cleanUrl.indexOf('?')) : cleanUrl;    
      storeKey = storeKey.replace('//', '/');  
      const cleanDataKeys =  state.dataKeys.filter(e => e !== storeKey);
      const isPaged = (cleanUrl.indexOf("page") > -1);
      let actionData;
      if (isPaged){
        if (state.dataEntities[storeKey]){
          actionData = state.dataEntities[storeKey]['data'];
          if(actionData['data']){
            if (action["payload"]["dataContent"]["data"] && Array.isArray(action["payload"]["dataContent"]["data"])){
              for (let newRow of action["payload"]["dataContent"]["data"]){
                newRow['outOfScope'] = true;
                actionData.data.push(newRow);
              }
            }
            
          }
          if (action["payload"]["dataContent"]["meta"]){
            actionData["meta"] = action["payload"]["dataContent"]["meta"];
          }
        }
        else{
          actionData = action["payload"]["dataContent"];
        }
      }
      else{
        actionData = action["payload"]["dataContent"];
      }
      return Object.assign({}, {
        dataLoading: false,
        dataLoaded: true,
        selectedDataKey: storeKey, //action["payload"]["apiUrl"],
        internalStateKey: state.internalStateKey,
        dataKeys: [...cleanDataKeys, storeKey],//action["payload"]["apiUrl"]],  
        dataEntities: Object.assign({}, state.dataEntities, { 
            [storeKey] : {
                createdOn: new Date(),
                expirationInterval: 300000000000,
                data: actionData
            }
        }),    
        dataSlice: {}, 
        internalState: state.internalState
      });
    }

    case coreActions.ActionTypes.PRELOAD_DATA_ITEM: 
    case coreActions.ActionTypes.LOAD_DATA_ITEM: {
      return Object.assign({}, {
        dataLoading: true,
        dataLoaded: false,
        selectedDataKey: action["payload"]["apiUrl"],
        internalStateKey: state.internalStateKey,
        dataKeys: state.dataKeys.slice(),            
        dataEntities: Object.assign({}, state.dataEntities),   
        dataSlice: {}, 
        internalState: state.internalState
      });
    }

    case coreActions.ActionTypes.EMPTY_STATE_KEYS: {    
      return Object.assign({}, {
        dataLoading: true,
        dataLoaded: false,
        selectedDataKey: "",
        internalStateKey: "",
        dataKeys: state.dataKeys.slice(),          
        dataEntities: Object.assign({}, state.dataEntities), 
        dataSlice: {}, 
        internalState: state.internalState
      });
    }

    case coreActions.ActionTypes.EMPTY_DATA_KEYS: {  
      const cleanDataObject = Object.assign({}, { "/navigation": state.dataEntities['/navigation']} );  
      const cleanDataKeyArray = ['/navigation'];
      return Object.assign({}, {
        dataLoading: true,
        dataLoaded: false,
        selectedDataKey: "",
        internalStateKey: "",
        dataKeys: cleanDataKeyArray,           
        dataEntities: Object.assign({}, cleanDataObject),
        dataSlice: {}, 
        internalState: state.internalState
      });
    }

    case coreActions.ActionTypes.LOAD_DATA_ITEM_FAIL: {
      return Object.assign({}, {
        dataLoading: false,
        dataLoaded: false,
        selectedDataKey: state.selectedDataKey,
        internalStateKey: null,
        dataKeys: state.dataKeys.slice(),
        dataEntities: Object.assign({}, state.dataEntities),
        dataSlice: {}, 
        internalState: state.internalState
      });
    }

    case coreActions.ActionTypes.REMOVE_SEARCH_DATA: {
      //let newStateData = {};
      Object.keys(state.dataEntities)
        .forEach(element => {
          if (element.indexOf('/search/') > -1 || element.indexOf('/tags/') > -1){
            delete state.dataEntities[element];
          }
        });
      return Object.assign({}, {
        dataLoading: false,
        dataLoaded: false,
        selectedDataKey: state.selectedDataKey,
        internalStateKey: null,
        dataKeys: state.dataKeys.slice(),
        dataEntities: Object.assign({}, state.dataEntities),
        dataSlice: {}, 
        internalState: state.internalState
      });
    }

    case coreActions.ActionTypes.REMOVE_SERIES_KEY: {
      //let newStateData = {};
      const key = action["payload"]["key"]
      delete state.dataEntities[key];
      const seasonsKey = key.replace('/series', '/seasons');
      const episodesKey = key.replace('/series', '/episodes'); 
      Object.keys(state.dataEntities)
      .forEach(element => {
        if (element.indexOf(seasonsKey) > -1 || element.indexOf(episodesKey) > -1){
          delete state.dataEntities[element];
        }
      });
      return Object.assign({}, {
        dataLoading: false,
        dataLoaded: false,
        selectedDataKey: state.selectedDataKey,
        internalStateKey: null,
        dataKeys: state.dataKeys.slice(),
        dataEntities: Object.assign({}, state.dataEntities),
        dataSlice: {}, 
        internalState: state.internalState
      });
    }

    case coreActions.ActionTypes.REMOVE_DATA_ENTITY_LIST: {
      //let newStateData = {};
      const keys = action["payload"]["keys"] as Array<string>;
      keys
      .forEach(key => {
        delete state.dataEntities[key];
      });
      return Object.assign({}, {
        dataLoading: false,
        dataLoaded: false,
        selectedDataKey: state.selectedDataKey,
        internalStateKey: null,
        dataKeys: state.dataKeys.slice(),
        dataEntities: Object.assign({}, state.dataEntities),
        dataSlice: {}, 
        internalState: state.internalState
      });
    }


    case coreActions.ActionTypes.SET_INTERNAL_STATE_VALUE: {   
      let newInternalState = Object.assign({}, state.internalState); 
      newInternalState[action["payload"]["key"]] = action["payload"]["value"];
      
      return Object.assign({}, {
        dataLoading: false,
        dataLoaded: true,
        selectedDataKey: state.selectedDataKey,
        internalStateKey: null,
        dataKeys: state.dataKeys.slice(),
        dataEntities: Object.assign({}, state.dataEntities),
        dataSlice: {}, 
        internalState: newInternalState
      });
    }
  
    case coreActions.ActionTypes.REPLACE_INTERNAL_STATE: {    
      let newInternalState = Object.assign({}, action["payload"]);
      return Object.assign({}, {
        dataLoading: false,
        dataLoaded: true,
        selectedDataKey: state.selectedDataKey,
        internalStateKey: null,
        dataKeys: state.dataKeys.slice(),
        dataEntities: Object.assign({}, state.dataEntities),
        dataSlice: {}, 
        internalState: newInternalState
      });
    }

    default: {
      //return state;
      if (state == initialDataState){
          //let stateValue = state;
          if (typeof window !== 'undefined') 
          {
            if (!!window && !!window['TRANSFER_STATE'] && !!window['TRANSFER_STATE'].ngrxState && !!window['TRANSFER_STATE'].ngrxState.reducer)
            {
              state = window['TRANSFER_STATE'].ngrxState.reducer;
            }
          } 
          //return stateValue;
      }
      action["payload"] = null;
      return state;
    }

    
  }
}

//entities
export const getDataEntities = (state: State) => state.dataEntities;
//loading state
export const getDataLoading = (state: State) => state.dataLoading;
export const getDataLoaded = (state: State) => state.dataLoaded;
export const getLoaded = (state: State) => state.dataLoading;
//selected state
export const getSelectedDataKey = (state: State) => state.selectedDataKey;
export const getInternalState = ( state : State ) => state.internalState;
export const selectStats = ( state : any  ) => state['video_stats'];
export const selectFavorites = ( state : any  ) => state['favorites'];

export const getSelectedDataEntity = createSelector(getDataEntities, getSelectedDataKey, (entities, selectedKey) => {
  if (selectedKey == null && entities == null){
    return Observable.of(null);
  }
  return entities[selectedKey];
});

export const getSelectedDataEntityData = createSelector(getDataEntities, getSelectedDataKey, (entities, selectedKey) => {
  if (selectedKey == null && entities == null){
    return Observable.of(null);
  }
  return entities[selectedKey].data;
});

export const selectReducer = createFeatureSelector<State>('reducer');
export const provideFavorites = createSelector( 
  selectReducer,
  (state: State)=>{
    const internalState = getInternalState( state );
    const favorites = selectFavorites( internalState );
    return favorites;
  }
)
export const provideVideoStats = createSelector(
  selectReducer,
  ( state: State ) =>{
     const internalState = getInternalState( state );
     const stats = selectStats( internalState );
     return stats;
  });


// WEBPACK FOOTER //
// ./src/angular-engine/engine/state/reducer/core.reducer.ts